import React, {
  createContext,
  useState,
  useContext,
  useCallback,
  useMemo,
} from "react";

// Initialize context with null to detect usage outside provider
const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState({
    id: null,
    userName: "",
    email: "",
    fullName: "",
    profilePicture: "", // URL to the profile picture
    // Add other persistent user fields if needed (e.g., roles)
  });
  const [isLoading, setIsLoading] = useState(true); // Loading state for initial user fetch

  // Use useCallback to memoize the updater function
  const updateUser = useCallback((newData) => {
    console.log("[UserContext] Updating user data:", newData);
    setUserData((prev) => ({ ...prev, ...newData }));
  }, []);

  // Use useCallback for setLoading
  const setLoading = useCallback((loadingState) => {
    console.log("[UserContext] Setting loading state:", loadingState);
    setIsLoading(loadingState);
  }, []);

  // Memoize the context value
  const contextValue = useMemo(
    () => ({
      userData,
      updateUser,
      isLoading,
      setLoading,
    }),
    [userData, updateUser, isLoading, setLoading]
  );

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
};

// Custom hook to consume the context
export const useUser = () => {
  const context = useContext(UserContext);
  // Throw an error if the hook is used outside of the UserProvider
  if (context === null) {
    throw new Error(
      "useUser must be used within a UserProvider. Make sure the component is wrapped in <UserProvider>."
    );
  }
  return context;
};
